// import React, { useState } from 'react';
// import { Outlet, NavLink, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import toast from 'react-hot-toast';

// const NAV = [
//   { to: '/', icon: '◈', label: 'Dashboard', exact: true },
//   { to: '/projects', icon: '◻', label: 'Projects' },
//   { to: '/quotations', icon: '◎', label: 'Quotations' },
//   { to: '/contacts', icon: '◉', label: 'Messages' },
//   { to: '/testimonials', icon: '❝', label: 'Testimonials' },
//   { to: '/services', icon: '◆', label: 'Services' },
//   { to: '/settings', icon: '⚙', label: 'Settings' },
// ];

// export default function AdminLayout() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const { user, logoutUser } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logoutUser();
//     toast.success('Logged out');
//     navigate('/login');
//   };

//   const Sidebar = () => (
//     <div className="flex flex-col h-full">
//       {/* Logo */}
//       <div className="px-6 py-5 border-b border-surface-700">
//         <div className="font-display font-semibold text-surface-100 text-lg leading-tight">DesignCraft</div>
//         <div className="text-brand-400 text-xs mt-0.5">Admin Panel</div>
//       </div>

//       {/* Nav */}
//       <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
//         {NAV.map(item => (
//           <NavLink
//             key={item.to}
//             to={item.to}
//             end={item.exact}
//             onClick={() => setSidebarOpen(false)}
//             className={({ isActive }) =>
//               `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-all ${
//                 isActive
//                   ? 'bg-brand-400/15 text-brand-400 font-medium border border-brand-400/20'
//                   : 'text-surface-400 hover:text-surface-200 hover:bg-surface-700'
//               }`
//             }
//           >
//             <span className="text-base w-5 text-center">{item.icon}</span>
//             {item.label}
//           </NavLink>
//         ))}
//       </nav>

//       {/* User */}
//       <div className="px-4 py-4 border-t border-surface-700">
//         <div className="flex items-center gap-3 mb-3">
//           <div className="w-8 h-8 bg-brand-400/20 border border-brand-400/30 rounded-full flex items-center justify-center text-brand-400 font-semibold text-sm">
//             {user?.name?.[0]?.toUpperCase()}
//           </div>
//           <div className="flex-1 min-w-0">
//             <p className="text-surface-200 text-sm font-medium truncate">{user?.name}</p>
//             <p className="text-surface-500 text-xs truncate">{user?.email}</p>
//           </div>
//         </div>
//         <button onClick={handleLogout} className="w-full text-left text-surface-500 hover:text-red-400 text-xs flex items-center gap-2 transition-colors py-1">
//           <span>⎋</span> Sign Out
//         </button>
//       </div>
//     </div>
//   );

//   return (
//     <div className="flex h-screen bg-surface-900 overflow-hidden">
//       {/* Desktop Sidebar */}
//       <aside className="hidden md:flex flex-col w-56 bg-surface-800 border-r border-surface-700 flex-shrink-0">
//         <Sidebar />
//       </aside>

//       {/* Mobile Sidebar Overlay */}
//       {sidebarOpen && (
//         <div className="md:hidden fixed inset-0 z-50 flex">
//           <div className="fixed inset-0 bg-surface-900/80" onClick={() => setSidebarOpen(false)} />
//           <aside className="relative w-56 bg-surface-800 border-r border-surface-700 z-10">
//             <Sidebar />
//           </aside>
//         </div>
//       )}

//       {/* Main content */}
//       <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
//         {/* Topbar */}
//         <header className="bg-surface-800 border-b border-surface-700 px-4 py-3 flex items-center justify-between flex-shrink-0">
//           <button onClick={() => setSidebarOpen(true)} className="md:hidden text-surface-400 hover:text-surface-200 p-1">
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//             </svg>
//           </button>
//           <div className="flex items-center gap-2 text-surface-400 text-sm">
//             <a href="http://localhost:3000" target="_blank" rel="noreferrer" className="hover:text-brand-400 transition-colors flex items-center gap-1.5">
//               <span>↗</span> View Website
//             </a>
//           </div>
//         </header>

//         {/* Page content */}
//         <main className="flex-1 overflow-y-auto p-4 md:p-6">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// }


// import React, { useState } from 'react';
// import { Outlet, NavLink, useNavigate } from 'react-router-dom';
// import {
//   LayoutDashboard, FolderKanban, Tag, Wrench, Star,
//   MessageSquare, FileText, Settings, LogOut, Menu, X,
//   ChevronRight, Bell, User, Shield
// } from 'lucide-react';
// import { useAuth } from '../context/AuthContext';
// import toast from 'react-hot-toast';

// const navItems = [
//   { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
//   { to: '/projects', icon: FolderKanban, label: 'Projects' },
//   { to: '/categories', icon: Tag, label: 'Categories' },
//   { to: '/services', icon: Wrench, label: 'Services' },
//   { to: '/testimonials', icon: Star, label: 'Testimonials' },
//   { to: '/quotations', icon: FileText, label: 'Quotations' },
//   { to: '/contacts', icon: MessageSquare, label: 'Contacts' },
//   { to: '/settings', icon: Settings, label: 'Settings' },
// ];

// export default function AdminLayout() {
//   const { user, logoutUser } = useAuth();
//   const navigate = useNavigate();
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const handleLogout = async () => {
//     await logoutUser();
//     toast.success('Logged out successfully');
//     navigate('/login');
//   };

//   const Sidebar = () => (
//     <aside className="flex flex-col h-full bg-surface-800 border-r border-white/8">
//       {/* Logo */}
//       <div className="flex items-center gap-3 px-5 py-4 border-b border-white/8">
//         <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
//           <Shield size={16} className="text-white" />
//         </div>
//         <div>
//           <div className="text-sm font-semibold text-white">Majestic Wood Crafts</div>
//           <div className="text-xs text-white/30">Admin Panel</div>
//         </div>
//       </div>

//       {/* Navigation */}
//       <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
//         <p className="text-white/25 text-[10px] font-semibold uppercase tracking-widest px-3 pb-2">Menu</p>
//        {navItems.map(({ to, icon: Icon, label, end }) => (
//   <NavLink
//     key={to}
//     to={to}
//     end={end}
//     onClick={() => setSidebarOpen(false)}
//     className={({ isActive }) =>
//       `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
       
//        ${isActive 
//          ? 'bg-primary-500/10 text-primary-400 shadow-inner' 
//          : 'text-white/70 hover:bg-white/5 hover:text-white'}`
//     }
//   >
//     {/* ICON */}
//     <Icon 
//       size={18} 
//       className="shrink-0 transition-transform duration-200 group-hover:scale-110" 
//     />

//     {/* TEXT */}
//     <span className="truncate">{label}</span>

//     {/* ARROW (optional hover effect) */}
//     <ChevronRight 
//       size={14} 
//       className="ml-auto opacity-0 translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200"
//     />
//   </NavLink>
// ))}
//       </nav>

//       {/* User info */}
//       <div className="p-3 border-t border-white/8">
//         <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-surface-700">
//           <div className="w-8 h-8 bg-primary-500/20 rounded-full flex items-center justify-center text-primary-400 font-semibold text-sm shrink-0">
//             {user?.name?.[0] || 'A'}
//           </div>
//           <div className="flex-1 min-w-0">
//             <div className="text-sm font-medium text-white truncate">{user?.name}</div>
//             <div className="text-xs text-white/30 truncate">{user?.role}</div>
//           </div>
//           <button onClick={handleLogout} className="p-1 text-white/30 hover:text-red-400 transition-colors" title="Logout">
//             <LogOut size={14} />
//           </button>
//         </div>
//       </div>
//     </aside>
//   );

//   return (
//     <div className="flex h-screen overflow-hidden">
//       {/* Desktop Sidebar */}
//       <div className="hidden md:flex md:w-56 lg:w-64 shrink-0 flex-col">
//         <Sidebar />
//       </div>

//       {/* Mobile Sidebar */}
//       {sidebarOpen && (
//         <div className="lg:hidden fixed inset-0 z-50 flex">
//           <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setSidebarOpen(false)} />
//           <div className="relative w-64 flex flex-col">
//             <Sidebar />
//           </div>
//           <button onClick={() => setSidebarOpen(false)} className="absolute top-4 right-4 text-white/60 hover:text-white">
//             <X size={20} />
//           </button>
//         </div>
//       )}

//       {/* Main content */}
//       <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
//         {/* Top bar */}
//         <header className="shrink-0 h-14 bg-surface-800 border-b border-white/8 flex items-center px-4 gap-3">
//           <button className="lg:hidden p-2 text-white/50 hover:text-white rounded-lg hover:bg-white/5" onClick={() => setSidebarOpen(true)}>
//             <Menu size={18} />
//           </button>
//           <div className="flex-1" />
//           <div className="flex items-center gap-2">
//             <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-surface-700 text-sm text-white/60">
//               <User size={13} className="text-primary-400" />
//               <span>{user?.name}</span>
//             </div>
//           </div>
//         </header>

//         {/* Page content */}
//         <main className="flex-1 overflow-y-auto p-4 md:p-6">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// }





import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, FolderKanban, Tag, Wrench, Star,
  MessageSquare, FileText, Settings, LogOut, Menu, X,
  ChevronRight, User, Shield
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const navItems = [
  { to: '/',            icon: LayoutDashboard, label: 'Dashboard',    end: true },
  { to: '/projects',    icon: FolderKanban,    label: 'Projects' },
  { to: '/categories',  icon: Tag,             label: 'Categories' },
  { to: '/services',    icon: Wrench,          label: 'Services' },
  { to: '/testimonials',icon: Star,            label: 'Testimonials' },
  { to: '/quotations',  icon: FileText,        label: 'Quotations' },
  { to: '/contacts',    icon: MessageSquare,   label: 'Contacts' },
  { to: '/settings',    icon: Settings,        label: 'Settings' },
];

/* ── Injected keyframes ── */
const STYLES = `
  @keyframes sidebarItemIn {
    from { opacity: 0; transform: translateX(-14px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes logoIn {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes pageIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes navPulse {
    0%   { box-shadow: 0 0 0 0 rgba(220,123,40,0.35); }
    70%  { box-shadow: 0 0 0 6px rgba(220,123,40,0); }
    100% { box-shadow: 0 0 0 0 rgba(220,123,40,0); }
  }
`;

/* ── Sidebar content ── */
function Sidebar({ onClose, user, onLogout }) {
  return (
    <aside className="flex flex-col h-full bg-surface-800 border-r border-white/8">
      <style>{STYLES}</style>

      {/* Logo */}
      <div
        className="flex items-center gap-3 px-5 py-4 border-b border-white/8"
        style={{ animation: 'logoIn 0.4s cubic-bezier(0.22,1,0.36,1) both' }}
      >
        <div
          className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center shrink-0"
          style={{ boxShadow: '0 0 16px rgba(220,123,40,0.35)' }}
        >
          <Shield size={16} className="text-white" />
        </div>
        <div>
          <div className="text-sm font-semibold text-white leading-tight">Majestic Wood Crafts</div>
          <div className="text-xs text-white/30">Admin Panel</div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 overflow-y-auto">
        <p className="text-white/25 text-[10px] font-semibold uppercase tracking-widest px-3 pb-2">
          Menu
        </p>

        <div className="space-y-0.5">
          {navItems.map(({ to, icon: Icon, label, end }, idx) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={onClose}
              style={{ animation: `sidebarItemIn 0.35s cubic-bezier(0.22,1,0.36,1) both`, animationDelay: `${50 + idx * 35}ms` }}
              className={({ isActive }) =>
                `group relative flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
                 ${isActive
                   ? 'bg-primary-500/12 text-primary-400'
                   : 'text-white/60 hover:bg-white/5 hover:text-white'
                 }`
              }
            >
              {({ isActive }) => (
                <>
                  {/* Active left bar */}
                  {isActive && (
                    <span
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: '20%',
                        bottom: '20%',
                        width: 3,
                        borderRadius: 2,
                        background: '#dc7b28',
                        animation: 'navPulse 0.6s ease',
                      }}
                    />
                  )}

                  <Icon
                    size={17}
                    className="shrink-0 transition-transform duration-200 group-hover:scale-110"
                  />
                  <span className="truncate flex-1">{label}</span>
                  <ChevronRight
                    size={12}
                    style={{
                      opacity: isActive ? 0.6 : 0,
                      transform: isActive ? 'translateX(0)' : 'translateX(-4px)',
                      transition: 'all 0.2s ease',
                      color: isActive ? '#dc7b28' : 'currentColor',
                    }}
                    className="group-hover:opacity-40 group-hover:translate-x-0"
                  />
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>

      {/* User info */}
      <div
        className="p-3 border-t border-white/8"
        style={{ animation: 'sidebarItemIn 0.4s ease both', animationDelay: '420ms' }}
      >
        <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-white/4 border border-white/6">
          {/* Avatar */}
          <div className="w-8 h-8 bg-primary-500/20 rounded-full flex items-center justify-center text-primary-400 font-semibold text-sm shrink-0">
            {user?.name?.[0] || 'A'}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-white truncate">{user?.name}</div>
            <div className="text-xs text-white/30 truncate capitalize">{user?.role}</div>
          </div>
          <button
            onClick={onLogout}
            className="p-1.5 rounded-lg text-white/30 hover:text-red-400 hover:bg-red-500/10 transition-all"
            title="Logout"
          >
            <LogOut size={13} />
          </button>
        </div>
      </div>
    </aside>
  );
}

export default function AdminLayout() {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pageKey, setPageKey] = useState(location.pathname);

  // Re-key the outlet on route change to trigger page-in animation
  useEffect(() => {
    setPageKey(location.pathname);
    setSidebarOpen(false);
  }, [location.pathname]);

  const handleLogout = async () => {
    await logoutUser();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <style>{STYLES}</style>

      {/* Desktop Sidebar */}
      <div className="hidden md:flex md:w-56 lg:w-64 shrink-0 flex-col">
        <Sidebar user={user} onLogout={handleLogout} onClose={() => {}} />
      </div>

      {/* Mobile Sidebar overlay */}
      {sidebarOpen && (
        <div className="md:hidden fixed inset-0 z-50 flex">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
            style={{ animation: 'pageIn 0.2s ease both' }}
          />
          <div
            className="relative w-64 flex flex-col"
            style={{ animation: 'sidebarItemIn 0.3s cubic-bezier(0.22,1,0.36,1) both' }}
          >
            <Sidebar user={user} onLogout={handleLogout} onClose={() => setSidebarOpen(false)} />
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">

        {/* Top bar */}
        <header className="shrink-0 h-14 bg-surface-800 border-b border-white/8 flex items-center px-4 gap-3">
          <button
            className="md:hidden p-2 text-white/50 hover:text-white rounded-lg hover:bg-white/5 transition-all"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu size={18} />
          </button>

          <div className="flex-1" />

          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/4 border border-white/6 text-sm text-white/60">
              <User size={13} className="text-primary-400" />
              <span className="hidden sm:inline">{user?.name}</span>
            </div>
          </div>
        </header>

        {/* Page content — re-animates on route change */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <div
            key={pageKey}
            style={{ animation: 'pageIn 0.3s cubic-bezier(0.22,1,0.36,1) both' }}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}